import React from "react";
import { Link as MUILink, Stack, Typography } from "@mui/material";
import StandardLabel from "../../../helpers/StandardLabel";
import { Link } from "react-router-dom";

const EmailUserDisplay = ({
  user,
}) => {
  return (
    <Stack>
      <StandardLabel labelText="User"/>
      {user.userEntityId === 0 ? (
        <Typography
          component="p"
          color="error"
        >
          Deleted User
        </Typography>
      ) : (
        <Link to={`../../users/${user.userEntityId}`}>
          <MUILink
            component="span"
          >
            {user.firstName || user.lastName ? (
              <>
                {user.firstName ? user.firstName + " " : ""}{user.lastName}
              </>
            ) : (
              <>
                No Name Provided
              </>
            )}
          </MUILink>
        </Link>
      )}
    </Stack>
  );
};

export default EmailUserDisplay;